import styled, {css} from 'styled-components';

import {mixins} from '../styles';
import {ERROR_NODE_HEIGHT} from './constants';

type TErrorProps = {
  width: string;
  height: string;
};

export const Error = styled.div<TErrorProps>`
  ${({theme, height, width}) => css`
    ${mixins.wh(width, height)}
    transition: all ${theme.animation.duration}ms;
  `};
`;

export const ErrorContent = styled.div`
  ${mixins.f2}
  /* stylelint-disable-next-line edna-stylelint/use-variables */
  line-height: ${ERROR_NODE_HEIGHT}px;
  ${({theme}) => css`
    color: ${theme.palette.red400};
    margin-top: ${theme.spacing.s1};
  `};
`;
